/**
 * 售后中心-评价分析-删评监控
 */

import { post, get, deleteApi, postJson, postUrl } from '../axios'

const RESOURCE_BASE_PATH = '/deleteCommentListener/'

// 查询商家已监控商品列表
export const getMonitorList = p => get(`${RESOURCE_BASE_PATH}`, p);

// 添加商品删评监控
export const addWareMonitor = p => postJson(`${RESOURCE_BASE_PATH}addWareMonitor`, p);

// 取消商品删评监控
export const cancelMonitor = p => postJson(`${RESOURCE_BASE_PATH}cancelMonitor`, p);

// 更新删评监控（刷新）
export const refreshMonitor = p => post(`${RESOURCE_BASE_PATH}refreshMonitor`, p);

// 获取店家已选商品
export const selectedWareList = p => get(`${RESOURCE_BASE_PATH}selectedWareList`, p);

// 查看商品评价（根据wareId）
export const wareComment = p => get(`${RESOURCE_BASE_PATH}wareComment`, p);

// 查询店铺商品列表（查询商品）
export const wareList = p => get(`${RESOURCE_BASE_PATH}wareList`, p);
